<script>
    /* КАРТОЧКА ЛОТА: слева — что продают, справа — торги.
       Ставка сделана в два шага (ввод → подтверждение), потому что отменить её
       нельзя: игрок должен успеть увидеть сумму и комиссию до нажатия. */
    import { onDestroy } from 'svelte'
    import { format } from 'api/formatter'
    import { TimeFormat } from 'api/moment'
    import { onInputFocus, onInputBlur } from '../../data'
    import Icon from './icon.svelte'
    import { catName, catIcon, lotPhoto, leftInfo, myState, betWord, niceName, sameName } from './data'

    export let lot = {};
    export let tick = 0;
    export let uuid = 0;
    export let name = '';
    export let onBet = () => {};
    export let onBack = () => {};

    let price = '';
    let confirm = false;
    let broken = false;

    $: state = myState (lot, uuid, name);
    $: left = tick >= 0 ? leftInfo (lot.time) : { text: '—', soon: false };
    $: photo = lotPhoto (lot);
    $: bets = (lot.betsList || []).slice ().reverse ();
    $: value = Number (String (price).replace (/[^0-9]/g, ""));
    $: step = Math.max (1000, Math.round ((lot.lastPrice || 0) * 0.05 / 1000) * 1000);

    const add = (sum) => {
        const base = value > (lot.lastPrice || 0) ? value : (lot.lastPrice || 0);
        price = String (base + sum);
        confirm = false;
    };

    const send = () => {
        if (!value) return window.notificationAdd (4, 9, 'Введите сумму ставки', 3000);
        if (value <= (lot.lastPrice || 0))
            return window.notificationAdd (4, 9, 'Ставка должна быть выше текущей', 3000);

        onBet (lot.id, value);
        price = '';
        confirm = false;
    };

    onDestroy (() => onInputBlur ());
</script>

<div class="mkpage">
    <div class="mktools">
        <div class="mkseg">
            <div class="on" on:keypress={() => {}} on:click={onBack}>← К витрине</div>
        </div>
        <p class="mkcount">{catName (lot.type)} · лот №{lot.id !== undefined ? lot.id : '—'}</p>
    </div>

    <div class="mkone">
        <div class="mkone__left">
            <div class="mkone__photo">
                {#if photo && !broken}
                    <img src={photo} alt="" on:error={() => broken = true}>
                {:else}
                    <div class="mkblank"><Icon name={catIcon (lot.type)}/></div>
                {/if}
                {#if state === 'own'}
                    <div class="mkchip own">Мой лот</div>
                {:else if state === 'lead'}
                    <div class="mkchip lead">Вы лидируете</div>
                {:else if state === 'outbid'}
                    <div class="mkchip outbid">Ставку перебили</div>
                {/if}
            </div>

            <div class="mkcard">
                <p class="mkcard__title">О лоте</p>
                <div class="mkfacts">
                    <div class="mkfact"><p>Категория</p><b>{catName (lot.type)}</b></div>
                    <div class="mkfact"><p>Продавец</p><b>{niceName (lot.createName) || '—'}</b></div>
                    <div class="mkfact"><p>Начальная цена</p><b>{format ("money", lot.createPrice || 0)}$</b></div>
                    <div class="mkfact"><p>Участников</p><b>{lot.betCount || 0} {betWord (lot.betCount)}</b></div>
                    <div class="mkfact"><p>Торги закончатся</p><b>{lot.time ? TimeFormat (lot.time, 'DD.MM в HH:mm') : '—'}</b></div>
                    <div class="mkfact"><p>Осталось</p><b class:soon={left.soon}>{left.text}</b></div>
                </div>
            </div>
        </div>

        <div class="mkone__right">
            <div class="mkcard">
                <p class="mkcard__title">Текущая ставка</p>
                <div class="mkbig">
                    <div>
                        <p class="mkbig__val">{format ("money", lot.lastPrice || 0)}$</p>
                        <p class="mkbig__sub">начинали с {format ("money", lot.createPrice || 0)}$</p>
                    </div>
                    {#if state === 'own'}
                        <div class="mkstate own">Ваш лот</div>
                    {:else if state === 'lead'}
                        <div class="mkstate lead">Ваша ставка старшая</div>
                    {:else if state === 'outbid'}
                        <div class="mkstate outbid">Вас перебили</div>
                    {/if}
                </div>
            </div>

            {#if lot.text}
                <div class="mkcard">
                    <p class="mkcard__title">Описание</p>
                    <p class="mknote">{lot.text}</p>
                </div>
            {/if}

            {#if state !== 'own' && lot.id !== undefined}
                <div class="mkcard">
                    <p class="mkcard__title">Ваша ставка</p>
                    <div class="mkbet">
                        <div class="mkinput">
                            <em>$</em>
                            <input type="text" bind:value={price} placeholder={String ((lot.lastPrice || 0) + step)}
                                   on:focus={onInputFocus} on:blur={onInputBlur} on:input={() => confirm = false}>
                        </div>
                        <div class="mkquick">
                            <div on:keypress={() => {}} on:click={() => add (step)}>+{format ("money", step)}</div>
                            <div on:keypress={() => {}} on:click={() => add (step * 2)}>+{format ("money", step * 2)}</div>
                            <div on:keypress={() => {}} on:click={() => add (step * 5)}>+{format ("money", step * 5)}</div>
                        </div>

                        {#if !confirm}
                            <div class="mkbtn" class:off={!value} on:keypress={() => {}}
                                 on:click={() => value && (confirm = true)}>Предложить цену</div>
                            <p class="mknote">Комиссия площадки — <b>1%</b> от ставки. Отменить ставку нельзя.</p>
                        {:else}
                            <p class="mknote">
                                Поставить <b>{format ("money", value)}$</b>? Комиссия составит
                                <b>{format ("money", Math.round (value / 100))}$</b>, отменить ставку будет нельзя.
                            </p>
                            <div class="mkbtn" on:keypress={() => {}} on:click={send}>Да, ставлю</div>
                            <div class="mkbtn ghost" on:keypress={() => {}} on:click={() => confirm = false}>Передумал</div>
                        {/if}
                    </div>
                </div>
            {/if}

            <div class="mkcard">
                <p class="mkcard__title">История ставок</p>
                {#if bets.length}
                    <div class="mkbets">
                        {#each bets as bet, index}
                            <div class="mkbet__row" class:top={index === 0} class:me={sameName (bet.name, name)}>
                                <span class="mkbet__n">{index + 1}</span>
                                <span class="mkbet__name">{niceName (bet.name)}</span>
                                <span class="mkbet__sum">{format ("money", bet.bet)}$</span>
                            </div>
                        {/each}
                    </div>
                {:else}
                    <p class="mknote">Ставок ещё не было — можно взять лот по стартовой цене.</p>
                {/if}
            </div>
        </div>
    </div>
</div>
